import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { NgModule } from '@angular/core';
@Component({
  selector: 'app-gotx-table',
  templateUrl: './gotx-table.component.html',
  styleUrls: ['./gotx-table.component.css']
})
export class GotxTableComponent implements OnInit {

  @Input('tableHeader') tableHeader: any[];
  @Input('tableRows') tableRows: any[];
  @Input('textAlign') textAlign: any[];
  @Input('textIndent') textIndent: any[];
  @Input('labelLink') labelLink: any[];

  @Output() selectedRow = new EventEmitter<String>();
  constructor() { }

  ngOnInit() {

  }

  rowClick(params) {
    this.selectedRow.emit(params);

  }
}
